<div class="rv-center my-medium">
  <logo></logo>
</div>
<div *ngIf="!_.needToResend">
  <form
    *ngIf="!_.submitted"
    class="rv-grid large"
    (ngSubmit)="_.validateAndSubmit()"
  >
    <div class="rv-title-05 bold rv-center">Reset your password</div>
    <riv-text-field
      name="email"
      label="Email"
      type="email"
      [value]="_.email"
      size="large"
      [disabled]="true"
    ></riv-text-field>
    <div class="rv-rows medium fill">
      <riv-text-field
        autocomplete="new-password"
        name="password"
        label="Enter a new password"
        placeholder="Enter your password"
        [value]="_.password"
        (valueChange)="_.setPassword($event); _.clearAllErrors()"
        [type]="_.showPassword ? 'text' : 'password'"
        size="large"
        [state]="_.passwordHasIssue ? 'error' : 'valid'"
      ></riv-text-field>
      <riv-text-field
        autocomplete="repeat-new-password"
        name="repeat-password"
        label="Confirm your new password"
        placeholder="Enter your password"
        [value]="_.repeatPassword"
        (valueChange)="_.setRepeatPassword($event); _.clearAllErrors()"
        [type]="_.showPassword ? 'text' : 'password'"
        size="large"
        [state]="_.repeatPasswordHasIssue ? 'error' : 'valid'"
      ></riv-text-field>
      <riv-checkbox
        identifier="show-password"
        [value]="_.showPassword"
        (valueChange)="_.setShowPassword($event)"
      >
        Show password
      </riv-checkbox>
      <div class="rv-explanation">
        {{ passwordRequirementsText }}
      </div>
    </div>
    <submit-error *ngIf="_.clientSideError">
      {{ _.clientSideError }}
    </submit-error>
    <submit-error *ngIf="_.submittingError">
      <span>{{ _.submittingError }}</span>
    </submit-error>
    <div class="rv-rows medium">
      <button
        rivButton
        variant="primary"
        [full]="true"
        size="xlarge"
        [disabled]="_.submitLoad.loading"
        type="submit"
      >
        {{ _.submitLoad.loading ? 'Resetting password...' : 'Reset password' }}
      </button>
      <button
        rivButton
        variant="basic"
        [full]="true"
        size="xlarge"
        routerLink="/login"
        [queryParams]="{ email: _.email }"
      >
        Back to login
      </button>
    </div>
  </form>
  <div *ngIf="_.submitted" class="rv-grid large rv-center">
    <div class="rv-title-05 bold">Your password has been reset!</div>
    <div class="body-paragraph">Log in with your new password.</div>
    <button
      rivButton
      variant="primary"
      [full]="true"
      size="xlarge"
      routerLink="/login"
      [queryParams]="{ email: _.email }"
    >
      Go to login
    </button>
  </div>
</div>
<div *ngIf="_.needToResend">
  <form class="rv-grid large" (ngSubmit)="_.validateAndResend()">
    <riv-banner>
      {{ _.needToResend.explanation }} Please verify your email address, then
      click Resend.
    </riv-banner>
    <riv-text-field
      name="email"
      label="Email"
      type="email"
      size="large"
      placeholder="Enter your email"
      [value]="_.email"
      (valueChange)="_.setEmail($event)"
      [state]="_.emailHasIssue ? 'error' : 'valid'"
    ></riv-text-field>
    <submit-error *ngIf="_.clientSideError">
      {{ _.clientSideError }}
    </submit-error>
    <submit-error *ngIf="_.submittingError">
      <span>{{ _.submittingError }}</span>
    </submit-error>
    <div class="rv-grid large">
      <button
        rivButton
        variant="primary"
        [full]="true"
        size="xlarge"
        [disabled]="_.resendLoad.loading"
        type="submit"
      >
        {{ _.resendLoad.loading ? 'Resending link...' : 'Resend link' }}
      </button>
      <button
        rivButton
        variant="basic"
        [full]="true"
        size="xlarge"
        routerLink="/login"
        [queryParams]="{ email: _.email }"
      >
        Back to login
      </button>
    </div>
  </form>
</div>
<div *ngIf="!_.envIsZelis" class="rv-explanation my-small rv-center">
  Need help? <a class="rv-link" (click)="openIntercom()">Contact support.</a>
</div>
